export default __webpack_public_path__ + "static/media/164.0a564d16.jpg";